<template>
  <div>
    <div class="form-container ou-donation-form arg">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Monto de donación">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>    
          <FormSection title="Información de la dedicación">
            <FormRow>
              <FormInput type="textarea" class="width-half" field="custom.Notes" />
            </FormRow>
          </FormSection>
          <FormSection title="Información Personal">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/" lang="esp"/>
                    </FormRow>       
          </FormSection>
          <FormSection title="Información de facturación">
            <DonorAddress />
          </FormSection>
          <FormSection title="Información de pago" last>
          <div class="total__amount" v-if="form.amount">
         Cantidad:
         <span>USD {{ amount }}</span>
          </div>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount btnText="Donar" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    const amount = computed(() =>
      form.value.handleProcessing
        ? Math.round((+form.value.amount! + +form.value.amount! * 0.025) * 100) / 100
        : +form.value.amount!
    );

    return {
      form,
      getValue,
      setValue,
      amount
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .form-container.ou-donation-form.arg{
  textarea{
    background: white;
  }
}

h2 {
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 20px;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.ou-donation-form ::v-deep h2 {
  font-size: 20px;
  text-transform: none;
  letter-spacing: normal;
}

.ou-donation-form ::v-deep .styled-radio.styled-radio--ou-donation.row {
  label {
    font-size: 14px !important;
  }
  &.styled-radio-container {
    label {
      font-size: 14px !important;
    }
    .radio-part {
      min-width: 28%;
      label {
        font-size: 14px !important;
      }
    }
  }
}
.ou-donation-form ::v-deep .forceShow label {
  font-size: 14px !important;
}

label.newsletter__label {
  padding-left: 7px;
}
.control-label {
  flex: 1;
  font-size: 14px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  color: #222;
  span {
    margin-bottom: 5px;
    padding-bottom: 3px;
    display: block;
  }
}

.donation__list {
  ul {
    padding: 0px 0px;
    margin: 0px 0px 11px;
    display: flex;
    flex-flow: wrap;
    gap: 1%;
    li {
      width: 49%;
      padding: 8px 2px;
      margin-bottom: 8px;
      background: #fafafa;
      text-align: center;
      border: 1px solid #cacaca;
      span {
        font-weight: bold;
        display: block;
        font-size: 16px;
      }
    }
  }
}

.holder__links {
    font-size: 18px;
    line-height: normal;
    color: black;
    font-weight: 600;
    padding-bottom: 5px;
    a{
      font-size: 18px;
    line-height: normal;
    font-weight: 600;
    }
}
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;

}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}
.total__amount{
  display: flex;
  gap: 7px;
  font-weight: bold;
    margin-bottom: 25px;
    span{
      color: #1AA8D3;
    font-weight: normal;
    }
}

::v-deep span.flex > span {
    display: flex;
}
</style>
